import React from 'react';

import classes from './PageTitle.module.scss';
import {
  BILLING_TYPE,
  BillingType,
} from '../../../../shared/constants/user-info/billingType';

type PageTitleProps = {
  billingType: BillingType;
};

const PageTitle = ({ billingType }: PageTitleProps) => {
  const titles = {
    [BILLING_TYPE.AUTOMATED_BILLING]: {
      title:
        'Double-check all information and pay for the subscription chosen by the coach',
      description: 'Proceed to the checkout with Stripe',
    },
    [BILLING_TYPE.SELF_BILLING]: {
      title: 'Double-check all information, select subscription and submit form',
      description: 'Select a subscription and proceed',
    },
  };

  return (
    <div className={classes.titleRow}>
      <h2 className={classes.title}>{titles[billingType].title}</h2>
      <p className={classes.description}>{titles[billingType].description}</p>
    </div>
  );
};

export { PageTitle };
